import { DEFAULT_DATA } from '../constants'

export const DEFAULT_MIXPANEL_DATA = {
  'Business': 'Travel',
  'Platform': 'Internal Vptravel',
  'Sub Sector': 'Travel',
  'Web App Version': __VERSION__,
  ...DEFAULT_DATA
}
